import { Button, type ButtonProperties } from '../../button';

export type ShareItemProperties = ButtonProperties;

const ShareItem = (props: ShareItemProperties) => <Button block type="vertical" {...props} />;

export default ShareItem;
